<!-- <iframe  [src]="updateVideoUrl()" width='100%' height='100%' scrolling='yes' style='border:0'></iframe> -->
<button type="button" class="btn btn-primary" style="background-color: #043C5A" [routerLink]="['../../appointment/']"><i class="fas fa-angle-left"></i> Back</button>

@if (!captchaActive()) {
  <div class="mt-3">
    <app-captcha [form]="form" captchaFieldName="recaptchaReactive"></app-captcha>
  </div>
}

<div style="height: 100%" [ngClass]="captchaActive() ? '' : 'd-none'">
  @if (data === 'lacassessorpublicservices') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorPublicServices@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }

  @if (data === 'lacassessordisabledveterans') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorDisabledVeterans@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }

  @if (data === 'lacassessormajorexemptions') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorMajorExemptions@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }

  @if (data === 'lacassessordatasales') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorDataSales@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }

  @if (data === 'lacassessoreastdistrict') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorEastDistrict@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }

  @if (data === 'lacassessorgismapping') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorGISMapping@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }

  @if (data === 'lacassessorhomeownersexemption') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorHomeownersExemption@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }

  @if (data === 'lacassessorwestdistrict') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorWestDistrict@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }

  @if (data === 'lacassessormanufacturedhomes') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorManufacturedHomes@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }

  @if (data === 'lacassessorownershipservices') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorOwnershipServices@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }

  @if (data === 'lacassessorpublicinformationofficer') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorPublicInformationOfficer@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }

  @if (data === 'lacassessorsouthdistrict') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorSouthDistrict@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }

  @if (data === 'lacassessornorthdistrict') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorNorthDistrict@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }

  @if (data === 'lacassessorlancasterdistrict') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorLancasterDistrict@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }

  @if (data === 'lacassessormajorrealproperty') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorMajorRealProperty@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }

  @if (data === 'lacassessorspecialinvestigations') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorSpecialInvestigations@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }

  @if (data === 'lacassessorbusinesspersonalproperty') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorBusinessPersonalProperty@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }
  @if (data === 'lacassessormarineaircraft') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorMarineAircraftAirlines@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }
  @if (data === 'lacassessormajorpersonalproperty') {
    <div style="height: 100%">
      <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorMajorPersonalProperties@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
    </div>
  }
</div>
